module.exports = __webpack_public_path__ + "img/生态基地6.ab766996.png";